import React from 'react';
import { motion } from 'framer-motion';
export function ProductPresentation() {
  return <section className="w-full bg-white py-12 md:py-20 px-4" data-id="element-314">
      <div className="max-w-5xl mx-auto text-center" data-id="element-315">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-316">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-8" data-id="element-317">
            🏆 El sistema de estudio más completo para estudiantes de
            Kinesiología en Argentina
          </h2>

          <div className="bg-slate-50 border-2 border-[#F0C040] rounded-xl p-8 md:p-12 mb-8" data-id="element-318">
            <h3 className="text-2xl md:text-3xl font-bold text-[#B8860B] mb-2" data-id="element-319">
              KINESIOLOGÍA: RESCATE ACADÉMICO™
            </h3>
            <p className="text-xl md:text-2xl text-slate-900 font-semibold mb-4" data-id="element-320">
              12 Tomos + 6 Bonos — Sistema Completo
            </p>
            <p className="text-lg text-slate-600 mb-6" data-id="element-321">
              Toda la carrera resuelta.
            </p>

            <div className="bg-white border border-slate-200 rounded-lg p-6 text-left" data-id="element-322">
              <p className="text-slate-700 leading-relaxed" data-id="element-323">
                +280 páginas · De Biomecánica al Título · Agentes Físicos,
                Clínica y Evaluación Kinésica · Casos clínicos resueltos · Guías
                de prácticas hospitalarias · Protocolos y parámetros listos ·
                Fichas de evaluación por región · 100% adaptado al plan de
                estudios argentino.
              </p>
              <p className="text-slate-600 mt-4 italic" data-id="element-324">
                También disponible en la versión Élite con 2 Ebooks de Autoridad
                Clínica.
              </p>
            </div>
          </div>

          {/* Product Mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex justify-center" data-id="element-325">
            <div className="relative w-64 h-80 bg-slate-100 rounded-lg shadow-xl border-4 border-[#F0C040] flex items-center justify-center p-6" data-id="element-326">
              <div className="text-center" data-id="element-327">
                <div className="text-6xl mb-4" data-id="element-328">📚</div>
                <div className="text-slate-900 font-bold text-xl mb-2" data-id="element-329">
                  RESCATE ACADÉMICO
                </div>
                <div className="text-slate-600 text-sm" data-id="element-330">12 Tomos + 6 Bonos</div>
                <div className="text-[#B8860B] text-xs mt-4 font-semibold" data-id="element-331">
                  280+ páginas
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}